import React from 'react';
import { TooltipTrigger } from '@spark';
import { CONTACT_US_LINK_LABEL } from '../constants';
import '../customer-intents.css';

/**
 * Tooltip body for a SaaS-gated control: "Contact us to enable …" where
 * "Contact us" is an underlined link that opens the customer-intents modal.
 * Without `onContactUs` (backend cannot file the request) the copy is plain.
 */
export function ContactUsTooltipContent({ text, onContactUs }) {
    if (!onContactUs || !text.startsWith(CONTACT_US_LINK_LABEL)) {
        return <p className="spark-tooltip-text">{text}</p>;
    }
    return (
        <p className="spark-tooltip-text customer-intent-tooltip">
            <button
                type="button"
                className="customer-intent-tooltip__link"
                // Keep focus (and the dropdown/tooltip) where it is; only the click matters.
                onMouseDown={(event) => event.preventDefault()}
                onClick={(event) => {
                    event.stopPropagation();
                    onContactUs();
                }}
            >
                {CONTACT_US_LINK_LABEL}
            </button>
            {text.slice(CONTACT_US_LINK_LABEL.length)}
        </p>
    );
}

/**
 * Wraps `children` in an interactive Spark tooltip carrying
 * `ContactUsTooltipContent`. Interactive only when there is a link to click.
 */
export default function ContactUsTooltip({ text, onContactUs, placement = 'top', className, children }) {
    return (
        <TooltipTrigger
            content={<ContactUsTooltipContent text={text} onContactUs={onContactUs} />}
            interactive={Boolean(onContactUs)}
            placement={placement}
            className={className}
        >
            {children}
        </TooltipTrigger>
    );
}
